// import React from "react";
// import Navbar from "./pages/navebar/Navebar.jsx";
// import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
// import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
// import Footer from "./pages/footer/Footer.jsx";
// import "./App.css";
// import "./Responsive.css";
// const App = () => {
//   return (
//     <>
//       <Navbar />
//       <Footer />
//     </>
//   );
// };
// export default App;
import React from 'react';
import navimg from "./assests/img/web.png";
import { ReactComponent as IconFacebook } from './assests/icons/facebook.svg';
import { ReactComponent as IconTwitter } from './assests/icons/twitter.svg';
import { ReactComponent as IconGithub } from './assests/icons/linkdin.svg';
import "./App.css";

class App extends React.Component {
  render = () => {
    return (
      <div className="card">
        <div className="header">
          <div className="logo">
            <a href=".">  <img className="title-logo"
                  src={navimg}
                  alt="img fail to load"
                  width="225px"
                  height="50px"
                /></a>
          </div>
        
          <div className="social">
            <a href="https://www.facebook.com/Softinfix" title="Facebook" target="_blank" rel="noopener noreferrer">
              <IconFacebook className="icon" />
            </a>
            {/* <a href="https://twitter.com" title="Twitter" target="_blank" rel="noopener noreferrer">
              <IconTwitter className="icon" />
            </a> */}
            <a href="https://www.linkedin.com/company/softinfix" title="GitHub" target="_blank" rel="noopener noreferrer">
              <IconGithub className="icon" />
            </a>
          </div>
        </div>
        <div className="content">
          <div className="title-holder">
            <h1>Get ready for the change.</h1>
            <p>Website coming soon. Please check back to know more. Shoot us an email if you're curious.</p>
          </div>
          <a href="mailto::Softinfix@gmail.com">
            <div className="cta">Send us an email</div>
          </a>
        </div>
        {/* <div className="footer">
          <span>made by <a className="underlined" href="https://github.com/arkn98" target="_blank" rel="noopener noreferrer">arkn98</a> using <a className="underlined" href="https://reactjs.org/" title="ReactJS" target="_blank" rel="noopener noreferrer">React</a> | <a className="underlined" href="https://github.com/arkn98/coming-soon" title="GitHub repo" target="_blank" rel="noopener noreferrer">GitHub</a></span>
        </div> */}
      </div>
    );
  }
}

export default App;